import { action as actionCreator } from "typesafe-actions";
import { asyncFailed, asyncHasFinished, asyncIsRunning, asyncNotStarted } from "@advosys/component-react-utils";
export var BackendAccessActionTypes;
(function (BackendAccessActionTypes) {
    BackendAccessActionTypes["GetClientIdentityRequest"] = "@@UNIK:domains:application:components:backend-access:backend-access-store:GetClientIdentityRequest";
    BackendAccessActionTypes["GetClientIdentitySuccess"] = "@@UNIK:domains:application:components:backend-access:backend-access-store:GetClientIdentitySuccess";
    BackendAccessActionTypes["GetClientIdentityFail"] = "@@UNIK:domains:application:components:backend-access:backend-access-store:GetClientIdentityFail";
    BackendAccessActionTypes["Clear"] = "@@UNIK:domains:application:components:backend-access:backend-access-store:Clear";
})(BackendAccessActionTypes || (BackendAccessActionTypes = {}));
export const backendActions = {
    getClientIdentityRequest: () => actionCreator(BackendAccessActionTypes.GetClientIdentityRequest),
    getClientIdentitySuccess: (clientIdentity) => actionCreator(BackendAccessActionTypes.GetClientIdentitySuccess, { clientIdentity }),
    getClientIdentityFail: (errorMessage) => actionCreator(BackendAccessActionTypes.GetClientIdentityFail, { errorMessage }),
    clear: () => actionCreator(BackendAccessActionTypes.Clear)
};
const initialState = {
    loading: asyncNotStarted
};
export const backendAccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case BackendAccessActionTypes.GetClientIdentityRequest:
            return { ...state, loading: asyncIsRunning };
        case BackendAccessActionTypes.GetClientIdentitySuccess:
            return { ...state, loading: asyncHasFinished(action.payload.clientIdentity) };
        case BackendAccessActionTypes.GetClientIdentityFail:
            return { ...state, loading: asyncFailed(action.payload.errorMessage) };
        case BackendAccessActionTypes.Clear:
            return initialState;
        default:
            return state;
    }
};
